/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Errors_Loadsellers1Inputs */

const id_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan memuat data penjual. Silakan coba lagi nanti.`)
};

const ms_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat memuat data penjual. Sila cuba lagi kemudian.`)
};

const da_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved indlæsning af sælgerdata. Prøv venligst igen senere.`)
};

const de_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Verkäuferdaten. Bitte später erneut versuchen.`)
};

const en_us2_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading sellers data. Please try again later.`)
};

const es_es2_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar los datos de vendedores. Inténtalo de nuevo más tarde.`)
};

const es_mx2_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar los datos de vendedores. Intenta de nuevo más tarde.`)
};

const fil_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pag-load ng data ng nagbebenta. Pakisubukan muli mamaya.`)
};

const fr_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des vendeurs. Veuillez réessayer plus tard.`)
};

const it_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante il caricamento dei dati dei venditori. Riprova più tardi.`)
};

const hu_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba az eladói adatok betöltésekor. Kérjük, próbáld újra később.`)
};

const nl_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij laden van verkopersgegevens. Probeer het later opnieuw.`)
};

const no_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved lasting av selgerdata. Prøv igjen senere.`)
};

const pl_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd ładowania danych sprzedawców. Spróbuj ponownie później.`)
};

const pt_br2_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar os dados dos vendedores. Por favor, tente novamente mais tarde.`)
};

const pt_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar dados dos vendedores. Tente novamente mais tarde.`)
};

const ro_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la încărcarea datelor vânzătorilor. Încearcă din nou mai târziu.`)
};

const fi_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe ladattaessa myyjätietoja. Yritä myöhemmin uudelleen.`)
};

const sv_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid inläsning av säljardata. Försök igen senare.`)
};

const vi_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi tải dữ liệu người bán. Vui lòng thử lại sau.`)
};

const tr_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı verileri yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.`)
};

const cs_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při načítání dat prodejců. Zkuste to prosím později.`)
};

const bg_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при зареждане на данните за продавачите. Моля, опитайте отново по-късно.`)
};

const ru_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка загрузки данных о продавцах. Пожалуйста, повторите попытку позже.`)
};

const uk_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка завантаження даних продавців. Спробуйте пізніше.`)
};

const ar_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في تحميل بيانات البائعين. حاول مرة أخرى لاحقًا.`)
};

const hi_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता डेटा लोड करने में त्रुटि। कृपया बाद में पुनः प्रयास करें।`)
};

const th_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการโหลดข้อมูลผู้ขาย กรุณาลองใหม่ภายหลัง`)
};

const ja_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元データの読み込みエラー。後でもう一度お試しください。`)
};

const zh_cn2_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载发行商数据出错。请稍后再试。`)
};

const zh_hant1_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入發行商資料出錯。請稍後再試。`)
};

const ko_freebies_errors_loadsellers1 = /** @type {(inputs: Freebies_Errors_Loadsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자 데이터를 불러오는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.`)
};

/**
* | output |
* | --- |
* | "Error loading sellers data. Please try again later." |
*
* @param {Freebies_Errors_Loadsellers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_errors_loadsellers1 = /** @type {((inputs?: Freebies_Errors_Loadsellers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Errors_Loadsellers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_errors_loadsellers1(inputs)
	if (locale === "ms") return ms_freebies_errors_loadsellers1(inputs)
	if (locale === "da") return da_freebies_errors_loadsellers1(inputs)
	if (locale === "de") return de_freebies_errors_loadsellers1(inputs)
	if (locale === "en-US") return en_us2_freebies_errors_loadsellers1(inputs)
	if (locale === "es-ES") return es_es2_freebies_errors_loadsellers1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_errors_loadsellers1(inputs)
	if (locale === "fil") return fil_freebies_errors_loadsellers1(inputs)
	if (locale === "fr") return fr_freebies_errors_loadsellers1(inputs)
	if (locale === "it") return it_freebies_errors_loadsellers1(inputs)
	if (locale === "hu") return hu_freebies_errors_loadsellers1(inputs)
	if (locale === "nl") return nl_freebies_errors_loadsellers1(inputs)
	if (locale === "no") return no_freebies_errors_loadsellers1(inputs)
	if (locale === "pl") return pl_freebies_errors_loadsellers1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_errors_loadsellers1(inputs)
	if (locale === "pt") return pt_freebies_errors_loadsellers1(inputs)
	if (locale === "ro") return ro_freebies_errors_loadsellers1(inputs)
	if (locale === "fi") return fi_freebies_errors_loadsellers1(inputs)
	if (locale === "sv") return sv_freebies_errors_loadsellers1(inputs)
	if (locale === "vi") return vi_freebies_errors_loadsellers1(inputs)
	if (locale === "tr") return tr_freebies_errors_loadsellers1(inputs)
	if (locale === "cs") return cs_freebies_errors_loadsellers1(inputs)
	if (locale === "bg") return bg_freebies_errors_loadsellers1(inputs)
	if (locale === "ru") return ru_freebies_errors_loadsellers1(inputs)
	if (locale === "uk") return uk_freebies_errors_loadsellers1(inputs)
	if (locale === "ar") return ar_freebies_errors_loadsellers1(inputs)
	if (locale === "hi") return hi_freebies_errors_loadsellers1(inputs)
	if (locale === "th") return th_freebies_errors_loadsellers1(inputs)
	if (locale === "ja") return ja_freebies_errors_loadsellers1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_errors_loadsellers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_errors_loadsellers1(inputs)
	return ko_freebies_errors_loadsellers1(inputs)
});
export { freebies_errors_loadsellers1 as "freebies.errors.loadSellers" }